/// <reference types="react-scripts" />
import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import * as publicUserService from "../../../models/services/publicUserService";
import LogoEsalkku from "../../../../../Content/devel/images/logo_eSalkku.png";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "source/framework/saveData";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { Alert, AlertTitle, Box, Grid, TextField } from "@mui/material";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { useRef, useState } from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import styled from "@emotion/styled";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IUserForgotPasswordPageContentProps {
    returnUrl: string;
}

export const ReCAPTCHAContainer = styled.div`
    position: relative;
    border: 1px solid #C4C4C4;
    background: #f9f9f9;
    padding: 0;

    .topHider {
        position: absolute;
        top: 0;
        left: 0;
        height: 2px !important;
        width: 100%;
        background-color: #f9f9f9;
    }

    .rightHider {
        position: absolute;
        top: 0;
        left: 295px;
        height: 100% !important;
        width: 15px;
        background-color: #f9f9f9;
    }

    .leftHider {
        position: absolute;
        top: 0;
        left: 0;
        height: 100% !important;
        width: 2px;
        background-color: #f9f9f9;
    }

    .bottomHider {
        position: absolute;
        bottom: 1px;
        left: 0;
        height: 2px !important;
        width: 100%;
        background-color: #f9f9f9;
    }
`;

export const UserForgotPasswordPageContent = (props: IUserForgotPasswordPageContentProps) => {
    const captchaRef = useRef(null);
    const [usercode, setUsercode] = useState("");
    const [captchaToken, setCaptchaToken] = useState("");
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    
    const handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "x_u_c") {
            setUsercode(value);
        }
    };
    
    const checkErrors = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            if (!usercode) {
                AppUtils.showErrorMessage(Translations.UserCodeMustBeDefined);
                return resolve(false);
            }
            return resolve(true);
        });
    };

    const captchaInUse = !!appConfig.googleReCAPTCHASiteKey;

    const resetCaptcha = async () => {
        if (!captchaInUse) return;
        captchaRef.current.reset();
        setCaptchaToken("");
    };

    const getSaveDataFromState = (): SaveDataObj => {
        const data = new SaveDataObj();
        data.append("usercode", usercode);
        data.append("token", captchaInUse ? captchaRef.current.getValue() : "");
        return data;
    };

    const handleChangePassword = async () => {
        if (!await AppUtils.validate(checkErrors)) return null;
        //Call server
        const saveData = getSaveDataFromState();
        const result = await AppUtils.callService(() => publicUserService.requestPasswordChange(saveData.obj), false);
        resetCaptcha();
        if (!result) return null;
        setShowSuccessDialog(true);
        return result;
    };

    const closeSuccessDialog = () => {
        setShowSuccessDialog(false);
        window.location.href = props.returnUrl ? Base.base64UrlDecode(props.returnUrl) : appConfig.loginUrl;
    };

    return (
        <div>
            <Box sx={{ maxWidth: "450px", marginLeft: "auto", marginRight: "auto", marginTop: "-50px", padding: "20px" }}>
                <Alert severity="info" sx={{ marginBottom: "0.5rem" }}>
                    <AlertTitle sx={{ fontWeight: "bold" }}>{Translations.RequestPasswordChangeTitle}</AlertTitle>
                    <Box component="span">{Translations.RequestPasswordChangeMessage1}</Box><Box component="span" sx={{ fontWeight: "bold" }}>{Translations.RequestPasswordChangeMessage2}</Box><Box component="span">{Translations.RequestPasswordChangeMessage3}</Box>
                </Alert>
                <GridRow>
                    <Grid item xs={12} sx={{ marginBottom: "1rem" }}>
                        <Box component="img" alt="logo" src={LogoEsalkku} sx={{ maxHeight: "100px", maxWidth: "100%" }} />
                    </Grid>
                </GridRow>
                <GridRow>
                    <Grid item xs={12}>
                        <FormField title={Translations.UserName} required margin="0.5rem 0 0 0">
                            <TextField type="text" name="x_u_c" title={Translations.UserName} inputProps={{ maxLength: 50, autoComplete: "off" }} value={usercode} required={true} onChange={handleChange} size="small" fullWidth />
                        </FormField>
                    </Grid>
                </GridRow>
                {captchaInUse &&
                    <GridRow>
                        <Grid item xs={12} sx={{ marginTop: ".5rem" }}>
                            <ReCAPTCHAContainer>
                                <ReCAPTCHA
                                    sitekey={appConfig.googleReCAPTCHASiteKey}
                                    ref={captchaRef}
                                    onChange={(value) => {
                                        setCaptchaToken(value);
                                    }}
                                />
                                <div className="topHider"></div>
                                <div className="rightHider"></div>
                                <div className="bottomHider"></div>
                                <div className="leftHider"></div>
                            </ReCAPTCHAContainer>
                        </Grid>
                    </GridRow>
                }
                <GridRow>
                    <Grid item xs={12}>
                        <AppButton variant="contained" sx={{ marginTop: "1rem" }} onClick={handleChangePassword} disabled={!usercode || (!!appConfig.googleReCAPTCHASiteKey && !captchaToken)} fullWidth>
                            {Translations.Send}
                        </AppButton>
                    </Grid>
                </GridRow>
            </Box>
            {showSuccessDialog &&
                <Dialog
                    id="passwordChangeRequestSuccessDialog"
                    maxWidth="xs"
                    title={Translations.RequestPasswordChangeLinkHasBeenSentTitle}
                    body={Translations.RequestPasswordChangeLinkHasBeenSent}
                    buttons={[
                        { title: Translations.Close, variant: "outlined", onClick: closeSuccessDialog }
                    ]}
                    onClose={closeSuccessDialog}
                />
            }
        </div>
    );
};